import { render } from "./task-manager.vue?vue&type=template&id=0d041e80"
import script from "./task-manager.vue?vue&type=script&lang=js"
export * from "./task-manager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__